<template>
  <div class="vp-container">
    <CustomSpinner />
  </div>
</template>
<style lang="scss" scoped src="./video-placeholder.scss"></style>
<script lang="ts" src="./video-placeholder.ts"></script>
